import Vue from 'vue';
import {
  Commit, Dispatch, ActionContext, Getter, ActionHandler, Store,
} from 'vuex/types';
import firebase from '@/plugins/firebase';
import moment from 'moment';
// @ts-ignore
import xml2js from 'xml2js';

const regex = /^(\S*)\s(\S*)\s\[([^\]]*)\]\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s"([^"]*)"\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s"([^"]*)"\s"([^"]*)"/;
// const regex = /^(\S*)\s(\S*)\s\[([^\]]*)\]\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s"([^"]*)"\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s"([^"]*)"\s"([^"]*)"\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s/;

interface S3LogLine{
  BucketOwner: string,
  Bucket: string,
  Time: number,
  RemoteIP: string,
  Requester: string,
  RequestID: string,
  Operation: string,
  Key: string,
  RequestURI: string,
  HTTPstatus: number,
  ErrorCode: string,
  BytesSent: number,
  ObjectSize: number,
  TotalTime: number,
  TurnAroundTime: number,
  Referrer: string,
  UserAgent: string,
  VersionId: string,
  HostId: string,
  SignatureVersion: string,
  CipherSuite: string,
  AuthenticationType: string,
  HostHeader: string,
  TLSversion: string,
}
class S3LogLine {
  constructor(line: string) {
    const fields = regex.exec(line);
    if (!fields) {
      return;
    }
    try {
      // this.BucketOwner = fields[1];
      this.Bucket = fields[2];
      this.Time = moment(fields[3], 'DD/MMM/YYYY:HH:mm:ss ZZ').unix();
      // this.RemoteIP = fields[4];
      // this.Requester = fields[5];
      // this.RequestID = fields[6];
      this.Operation = fields[7];
      this.Key = decodeURIComponent(fields[8]);
      // this.RequestURI = fields[9];
      // this.HTTPstatus = parseInt(fields[10]);
      // this.ErrorCode = fields[11];
      // this.BytesSent = parseInt(fields[12]);
      this.ObjectSize = parseInt(fields[13]);
      // this.TotalTime = parseInt(fields[14]);
      // this.TurnAroundTime = parseInt(fields[15]);
      // this.Referrer = fields[16];
      // this.UserAgent = fields[17];
      // this.VersionId = fields[18];
      // this.HostId = fields[19];
      // this.SignatureVersion = fields[20];
      // this.CipherSuite = fields[21];
      // this.AuthenticationType = fields[22];
      // this.HostHeader = fields[23];
      // this.TLSversion = fields[24];
    } catch {
      //
    }
  }
}
interface Log {
  key: string,
  etag: string,
  bucket: string,
  cached: boolean,
  events: S3LogLine[],
  overflow: boolean,
}
interface Logs {
  [key: string]: Log,
}
interface State {
  logs: Logs,
}
export default {
  namespaced: true,
  state: {
  	logs: {},
    events: {},
  },
  mutations: {
    insertOrUpdate(state: any, data: any) {
      data = JSON.parse(JSON.stringify(data));
      if (!data) {
        return;
      }
      if (state.logs[data.key]) {
        for (const key of Object.keys(data)) {
          Vue.set(state.logs[data.key], key, data[key]);
        }
        return state.logs[data.key];
      }
      if (!Array.isArray(data.events)) {
        data.events = [];
      }
      Vue.set(state.logs, data.key, data);
      return state.logs[data.key];
    },
    addEvents(state: any, { log, events } : {log: Log, events: S3LogLine[]}) {
      events.forEach((event) => {
        log.events.push(event);
      });
    },
  },
  getters: {
    events: (state: State) => (from: number, to: number) => {
      if (!to) {
        to = moment().unix();
      }
      from = moment.unix(from).startOf('day').unix();
      to = moment.unix(to).endOf('day').unix();
      const events: S3LogLine[] = [];
      for (const logKey of Object.keys(state.logs)) {
        // raw_2019-04-23-10-19-13-17WSW5NTQ7VMVUYI
        try {
          const match = logKey.match(/\d{4}\-\d{2}\-\d{2}\-\d{2}\-\d{2}\-\d{2}/);
          if (match == null) {
            continue;
          }
          const logMoment = moment(match[0], 'YYYY-MM-DD-HH-mm-ss');
          if (logMoment.unix() < from) {
            continue;
          }
          if (logMoment.unix() > to) {
            continue;
          }
        } catch {
          continue;
        }
        if (Array.isArray(state.logs[logKey].events)) {
          state.logs[logKey].events.forEach((event) => {
            if (from < event.Time && event.Time < to) {
              events.push(event);
            }
          });
        }
      }
      return events;
    },
  },
  actions: {
    async fetchRange({
      commit, state, getters, dispatch,
    } : ActionContext<State, any>, { from, to, callback } : {from: number, to: number, callback: (status: string, progress: number) => {}}) {
      if (!to) {
        to = moment().unix();
      }
      from = moment.unix(from).startOf('day').unix();
      to = moment.unix(to).endOf('day').unix();
      const logs = [];
      for (const logKey of Object.keys(state.logs)) {
        // raw_2019-04-23-10-19-13-17WSW5NTQ7VMVUYI
        try {
          const match = logKey.match(/\d{4}\-\d{2}\-\d{2}\-\d{2}\-\d{2}\-\d{2}/);
          if (match == null) {
            continue;
          }
          const logMoment = moment(match[0], 'YYYY-MM-DD-HH-mm-ss');
          if (logMoment.unix() < from) {
            continue;
          }
          if (logMoment.unix() > to) {
            continue;
          }
        } catch {
          continue;
        }
        logs.push(logKey);
      }
      const events: S3LogLine[] = [];
      let i = 0;
      for (const logKey of logs) {
        i++;
        if (!state.logs[logKey].cached) {
          await dispatch('fetch', state.logs[logKey]).catch(error => console.log(error));
        }
        callback(`Reading logs ${i}/${logs.length}`, i / logs.length);
        if (Array.isArray(state.logs[logKey].events)) {
          state.logs[logKey].events.forEach((event) => {
            if (from < event.Time && event.Time < to) {
              events.push(event);
            }
          });
        }
      }
      return events;
    },
    fetchLogIndex({
      commit, state, getters, dispatch,
    } : ActionContext<any, any>, callback: (status: string, progress: number) => {}) {
      return new Promise((resolve, reject) => {
        const policyRequest = firebase.app().functions('europe-west1').httpsCallable('wasabi');
        policyRequest({ bucket: 'supercruiser-logs', key: '' }).then(({ data }) => {
          fetch(data.url).then(response => response.json()).then((data) => {
            xml2js.parseString(data, async (err: any, result: any) => {
              const i = 0;
              for (const object of result.ListBucketResult.Contents) {
                // i++;
                // if (i > 3){
                //   break;
                // }
                commit('insertOrUpdate', { bucket: 'supercruiser-logs', key: object.Key[0], etag: object.ETag[0] });
              }
              resolve();
            });
          }).catch(error => console.log(error));
        }).catch(error => console.log(error));
      });
    },
    fetch({
      commit, state, getters, dispatch,
    } : ActionContext<any, any>, log: Log) {
      if (log.cached) {
        return;
      }
      log.cached = true;
      return new Promise((resolve, reject) => {
        firebase.firestore().collection(log.bucket).doc(log.key).get()
          .then((doc) => {
            const data = doc.data();
            if (!data || data.etag !== log.etag) {
              dispatch('processLogFile', log).then(logData => resolve(dispatch('fetch', log))).catch(error => reject(error));
            } else {
              resolve(commit('insertOrUpdate', { ...data, key: log.key }));
              if (data.overflow) {
                dispatch('fetchOverflow', log);
              }
            }
          })
          .catch((error) => {
            console.log(error);
            dispatch('processLogFile', log).then((events) => {
              commit('addEvents', { log, events });
            }).catch(error => reject(error));
          });
      });
    },
    fetchOverflow({
      commit, state, getters, dispatch,
    } : ActionContext<any, any>, log: Log) {
      return new Promise((resolve, reject) => {
        firebase.firestore().collection(log.bucket).doc(log.key).collection('overflow')
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((document) => {
              commit('addEvents', {
                log,
                events: document.data().events,
              });
            });
          });
      });
    },
    processLogFile({
      commit, state, getters, dispatch,
    } : ActionContext<any, any>, log: Log) {
      return new Promise((resolve, reject) => {
        const policyRequest = firebase.app().functions('europe-west1').httpsCallable('wasabi');
        policyRequest({ bucket: log.bucket, key: log.key }).then(({ data }) => {
          fetch(data.url).then(response => response.json()).then((data) => {
            const lines: string[] = data.match(/[^\r\n]+/g);
            let fields;
            let s3LogLine: S3LogLine;
            // let regex = /(\S*)\s(\S*)\s\[(^\]*)\]\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s"(^"*)"\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s"(^"*)"\s"(^"*)"\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s(\S*)\s/;
            // regex = /^(\S*)\s(\S*)\s/
            lines.forEach((line) => {
              s3LogLine = new S3LogLine(line);
              if (['REST.PUT.OBJECT', 'REST.POST.UPLOAD'].includes(s3LogLine.Operation)) {
                if (s3LogLine.ObjectSize > 0) {
                  log.events.push(s3LogLine);
                }
              }
            });
            const overflow: S3LogLine[] = [];
            let json = JSON.stringify(log);
            while (json.length * 2 > 1 * 1024 * 1024) { // Doc size limit
              log.overflow = true;
              if (log.events.length === 0) {
                reject('Could not reduce doc size');
              }
              overflow.push(log.events.pop()!);
              json = JSON.stringify(log);
            }
            const ref = firebase.firestore().collection(log.bucket).doc(log.key);
            ref.set(JSON.parse(json), { merge: true }).then(() => {
              while (overflow.length > 0) {
                const extra = { events: [...overflow] };
                overflow.length = 0;
                json = JSON.stringify(extra);
                while (json.length * 2 > 1 * 1024 * 1024) { // Doc size limit
                  overflow.push(extra.events.pop()!);
                  json = JSON.stringify(extra);
                }
                ref.collection('overflow').add(JSON.parse(json)).then((ref) => {
                  commit('addEvents', { log, events: extra.events });
                });
              }
              resolve(log);
            }).catch((error) => {
              reject(error);
            });
            // return response;
          }).catch(error => reject(error));
          // resolve(commit('addSuggestion', result));
        }).catch(error => reject(error));
      });
    },
  },
};
